import { call, put, takeLeading } from 'redux-saga/effects'

import getExternalCourse from 'api/externalCourses/Get'
import { onHttpError } from 'helpers/access.helper'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { PayloadGetExternalCourse } from '../../actions/externalCourses.action'
import {
  Actions,
  GET_EXTERNAL_COURSE,
} from '../../actions/externalCourses.action'

function handleGetExternalCourse(
  externalCourseId: PayloadGetExternalCourse['id']
) {
  return getExternalCourse(externalCourseId)
}

const pattern = GET_EXTERNAL_COURSE

export type DestroyExternalCoursesAction = ActionWithPayload<
  typeof pattern,
  PayloadGetExternalCourse
>

function* getExternalCourseEffectSaga(action: DestroyExternalCoursesAction) {
  try {
    const { id } = action.payload
    yield put(Actions.getExternalCourseLoading(true))
    const data = yield call(handleGetExternalCourse, id)
    yield put(Actions.getExternalCourseSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* getExternalCourseWatcherSaga() {
  yield takeLeading(pattern, getExternalCourseEffectSaga)
}
